// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav__1wi7u","logo-wrapper":"logo-wrapper__3qMyA","logo":"logo__1YXHk"};